import type { AsyncThunkApiConfig } from '@/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type AccountData = uui.domain.actions.rpc.user.UpdateSessionUserAction['account']

export const updateSessionUser = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  AccountData,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/user/updateSessionUser', async (account, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/updateSessionUser', {
      type: 'rpc/user/updateSessionUser',
      category: 'rpc',
      account,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        error: result,
        message: result.errorMessage,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      error,
      type: 'unknown',
      message: 'Failed to update the User Account',
    })
  }
})
